<template>
  <div :class="classes">
    <i></i>
    {{text}}
  </div>
</template>

<script>
export default {
  props: ['state'],
  computed: {
    classes: {
      get(){
        return {
          state_label: true,
          on: this.state == 0,
          off: this.state == 1
        }
      }
    },
    text: {
      get(){
        var t = {
          0: '在线',
          1: '离线'
        }
        return t[this.state]
      }
    }
  }
}
</script>


<style lang="scss" scoped>
.state_label{
  i{
    width: 16px;
    height: 16px;
    background: #ddd;
    display: inline-block;
    vertical-align: middle;
    border-radius: 4px;
  }

  &.on i{
    background: #62cb31
  }
  &.off i{
    background: #ddd
  }
}
</style>




// WEBPACK FOOTER //
// src/component/base-state.vue